import cloneDeep from 'lodash.clonedeep'

export const mapRelations = data => {
  if (!data.included) {
    return data
  }

  const mainData = cloneDeep(data)
  const listItems = mainData.data
  let mappedData

  if (Array.isArray(listItems)) {
    mappedData = listItems.map(object => findRelationships(object, data))
  } else {
    mappedData = findRelationships(listItems, data)
  }


  return { data: mappedData, meta: mainData.meta }
}

function findRelationships(object, data) {
  if (!object.relationships) {
    return object
  }

  const relationships = Object.keys(object.relationships)

  relationships.forEach(key => {
    const relatedObjects = object.relationships[key]?.data

    if (!relatedObjects) return object

    if (Array.isArray(relatedObjects)) {
      object[key] = relatedObjects
        .map(related => {
          return data.included.find(rel => related.id.uuid === rel.id.uuid)
        })
        .filter(Boolean)
    } else {
      object[key] = data.included.find(rel => relatedObjects.id.uuid === rel.id.uuid)
    }

    // A RELATED OBJECT CAN HAVE RELATIONSHIPS ALSO LIKE AL LISTING IN A TRANSACTIONS CAN HAVE AN IMAGE
    if (Array.isArray(object[key])) {
      object[key]
        .map(related => {
          if (related?.relationships) {
            findRelationships(related, data)
          }
        })
        .filter(Boolean)
    } else {
      if (object[key]?.relationships) {
        findRelationships(object[key], data)
      }
    }
  })

  return object
}
